import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataModelService } from '@services/data-model.service';
import { ItemModalComponent } from '@scaffold/editor/item-modal/item-modal.component';
import { SettingsService } from '@scaffold/services/settings.service';
import { ItemsService } from '@scaffold/services/items.service';
import { Location } from '@angular/common';
import { HttpUtilService } from '@services/http-util.service';
import { environment } from '@env/environment';
import cloneDeep from 'lodash/cloneDeep';
import { NbDialogService, NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'app-key-items',
    templateUrl: './key-items.component.html',
    styleUrls: ['./key-items.component.scss']
})
export class KeyItemsComponent implements OnInit {
    
    constructor(
      private dataModelService: DataModelService,
      private dialog: NbDialogService,
        private route : ActivatedRoute,
        private settingsService : SettingsService,
        private itemsService : ItemsService,
        public location : Location,
        private httpUtils: HttpUtilService
        ) { 
        settingsService.getSettings().subscribe(settings => this.settings = settings);
        itemsService.getItems().subscribe(item_list => this.items_list = item_list);
    }
    
    modelId;
    type;
    keyName;
    key;
    // keyUpdated = [];
    keyUpdated: Boolean;
    editExpand: Boolean = false;
    readExpand: Boolean = false;
    settings;
    items_list;
  lmsList = [];
  dialogRef: NbDialogRef<ItemModalComponent>;
    componentCopy: any;
    
    ngOnInit() {
        this.route.paramMap.subscribe( params => {
            this.modelId = params.get('id');
            this.keyName = params.get('key');

            this.dataModelService.getTypes(this.modelId).subscribe(type => this.type = type[0])
            
            this.dataModelService.getKeys(this.modelId, this.keyName).subscribe( keyResp => {
                this.key = keyResp[0];

                if (this.key.item_desc == null) {
                    this.key.item_desc = {
                        write : null,
                        read  : null
                    };
                }
                this.componentCopy = cloneDeep(this.key.item_desc);
                // console.log(this.componentCopy);
            })
        })
        this.httpUtils.authGet(environment.apiRoot + "/institution/lms").subscribe(lmsConfig => {
            var lmsList = Object.keys(lmsConfig);

            for (var i = 0; i < lmsList.length; i++) {
                var lms = lmsList[i];

                if (lmsConfig[lms]) {
                    this.lmsList.push(lms)
                }
            }
        })
    }
    
  openItemDialog(IO) {
    let settings: any = {
      context: {
        data: {
          list: this.items_list, item: { type: 'key-' + IO }, parents: []
        }
      }
    };
        this.dialogRef = this.dialog.open(ItemModalComponent, settings);

      this.dialogRef.onClose.subscribe(result => {
            if (result && (typeof result !== 'string' || result.length > 0)) {
                // Inject this key's name into the object settings
                result.name = this.keyName
                this.key.item_desc[IO] = result;
                this.keyUpdated = true;

                if (IO == 'read') { this.readExpand = true; }
                if (IO == 'write') { this.editExpand = true; }
            }
        });
    }

    saveKey() {
        console.log('key updated 1 ' + this.keyUpdated);
        this.dataModelService.updateKey(this.modelId, this.key).subscribe();
        console.log(this.modelId, this.key);
        // this.location.back();
        this.keyUpdated = false;
        this.componentCopy = cloneDeep(this.key.item_desc);
        console.log('key updated 2 ' + this.keyUpdated);

    }

    componentUpdated() {
        return JSON.stringify(this.componentCopy) != JSON.stringify(this.key.item_desc)
    }
    
}
